import { Container, Row , Col} from "react-bootstrap"
import { Login } from "../Login/Login"

export const LogInPage = () => {
  return (
    <Container>
        <Row className="justify-content-center align-items-center">
            <Col md={8}>
                <Login />
            </Col>
        </Row>
    </Container>
  )
}
